/* ============================================================
   Delivery Popup — Premium Accordion Logic
   ============================================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'dp_delivery_data';
  const STORAGE_TTL = 60 * 60 * 1000; // 1 hour

  var HEBREW_DAYS   = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
  var SLOTS_REGULAR = ['08:00–10:00', '10:00–12:00', '12:00–14:00', '14:00–16:00', '16:00–18:00', '18:00–20:00'];
  var SLOTS_FRIDAY  = ['08:00–10:00', '10:00–12:00', '12:00–14:00'];

  // ── Helpers ────────────────────────────────────────────────
  function padZ(n) { return String(n).padStart(2, '0'); }
  function fmt(date) { return padZ(date.getDate()) + '-' + padZ(date.getMonth() + 1) + '-' + date.getFullYear(); }
  function addDays(date, n) { const d = new Date(date); d.setDate(d.getDate() + n); return d; }
  function parseDate(dateStr) {
    var p = dateStr.split('-');
    return new Date(+p[2], +p[1] - 1, +p[0]);
  }
  function getAvailableDates() {
    var now  = new Date();
    var list = [];
    var d;

    if (now.getHours() < 19) {
      // Today is allowed only if it has at least one slot starting >= now+2h
      var minStart     = now.getHours() + 2;
      var todaySlots   = now.getDay() === 5 ? SLOTS_FRIDAY : SLOTS_REGULAR;
      var todayHasSlot;
      if (now.getDay() === 5) {
        // Friday: allow same-day ordering until 15:00
        todayHasSlot = now.getHours() < 15;
      } else {
        todayHasSlot = now.getDay() !== 6 && todaySlots.some(function (s) {
          return parseInt(s.split('–')[0], 10) >= minStart;
        });
      }
      d = todayHasSlot ? new Date(now) : addDays(now, 1);
    } else {
      // 19:00 or later — earliest is tomorrow
      d = addDays(now, 1);
    }

    while (list.length < 3) {
      if (d.getDay() !== 6) list.push(new Date(d)); // skip Saturday
      d = addDays(d, 1);
    }
    return list;
  }
  function saveStorage(data) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, data, { savedAt: Date.now() }))); } catch (_) {} }
  function loadStorage() {
    try {
      var d = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!d) return null;
      if (d.savedAt && Date.now() - d.savedAt > STORAGE_TTL) { localStorage.removeItem(STORAGE_KEY); return null; }
      return d;
    } catch (_) { return null; }
  }

  async function saveCartAttributes(data) {
    const attr = {};

    attr['🚚 אופן קבלה']    = data.deliveryType === 'self' ? 'איסוף עצמי' : 'משלוח עם שליח';
    if (data.date)     attr['📅 תאריך אספקה'] = data.date;
    if (data.timeSlot) attr['⏰ שעת אספקה']   = data.timeSlot;

    if (data.deliveryType === 'delivery') {
      if (data.addressType === 'private') {
        if (data.city)            attr['📍 עיר']         = data.city;
        if (data.street)          attr['📍 רחוב']        = data.street;
        if (data.houseNumber)     attr['📍 מספר בית']    = data.houseNumber;
        if (data.apartmentNumber) attr['📍 מספר דירה']   = data.apartmentNumber;
      } else if (data.addressType === 'hospital') {
        if (data.hospitalName) attr['🏥 שם בית החולים']         = data.hospitalName;
        if (data.department)   attr['🏥 מחלקה']                  = data.department;
        if (data.building)     attr['🏥 בניין']                   = data.building;
        if (data.floor)        attr['🏥 קומה']                    = data.floor;
      }
      if (data.recipientName)  attr['👤 מקבל המשלוח - שם']    = data.recipientName;
      if (data.recipientPhone) attr['📞 מקבל המשלוח - טלפון'] = data.recipientPhone;
      if (data.orderNote)      attr['📝 מקבל המשלוח - הערה']  = data.orderNote;
    }
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attr }),
      });
    } catch (e) { console.warn('dp: cart update failed', e); }
  }

  // ── State ──────────────────────────────────────────────────
  function freshState() {
    return {
      deliveryType: null, date: null, timeSlot: null, addressType: null,
      city: '', street: '', houseNumber: '', apartmentNumber: '',
      hospitalName: '', department: '', building: '', floor: '',
      recipientName: '', recipientPhone: '', orderNote: '',
    };
  }
  let state = freshState();

  // ── Checkout-pending flag ──────────────────────────────────
  // When the user dismisses the popup without filling it, we allow checkout to proceed.
  var _pendingCheckoutTrigger = null;

  // ── DOM refs ───────────────────────────────────────────────
  let overlay, modal,
      sec1, sec2, sec3, sec4,
      sum1, sum2, sum3, sum4,
      quickContainer, quickBtns, dateInput, calendarBtn,
      dateErrorMsg,
      privateFields, hospitalFields,
      cityField, streetField, houseField, apartmentField,
      hospitalNameField, departmentField, buildingField, floorField,
      recipientNameField, recipientPhoneField, orderNoteField,
      submitBtn;

  // ── Progress dots ──────────────────────────────────────────
  function updateProgress(completedUpTo) {
    [1, 2, 3, 4].forEach(n => {
      const dot  = document.querySelector('[data-prog="'      + n + '"]');
      const line = document.querySelector('[data-prog-line="' + n + '"]');
      if (!dot) return;
      dot.classList.toggle('dp-prog-done',   n <= completedUpTo);
      dot.classList.toggle('dp-prog-active', n === completedUpTo + 1);
      if (line) line.classList.toggle('dp-prog-done', n <= completedUpTo);
    });
  }

  // ── Accordion open / mark-done ─────────────────────────────
  function openSection(n) {
    [sec1, sec2, sec3, sec4].forEach(function (s, i) {
      if (!s) return;
      var isTarget = (i + 1 === n);
      s.classList.toggle('dp-section--active', isTarget);
      if (!isTarget) {
        if (!s.classList.contains('dp-section--done')) {
          s.classList.add('dp-section--locked');
        }
      } else {
        s.classList.remove('dp-section--locked', 'dp-section--done');
      }
    });
  }

  function markDone(n, summaryText) {
    var secs = [sec1, sec2, sec3, sec4];
    var sums = [sum1, sum2, sum3, sum4];
    var sec  = secs[n - 1];
    var sum  = sums[n - 1];
    if (!sec) return;
    sec.classList.remove('dp-section--active', 'dp-section--locked');
    sec.classList.add('dp-section--done');
    if (sum) sum.textContent = summaryText;
  }

  // ── Quick-date buttons ─────────────────────────────────────
  function buildQuickDates() {
    if (!quickContainer) return;
    quickContainer.innerHTML = '';
    var available = getAvailableDates();
    var todayStr    = fmt(new Date());
    var tomorrowStr = fmt(addDays(new Date(), 1));
    available.forEach(function (d) {
      var ds    = fmt(d);
      var label = ds === todayStr    ? 'היום'
                : ds === tomorrowStr ? 'מחר'
                : HEBREW_DAYS[d.getDay()];
      var btn = document.createElement('button');
      btn.type         = 'button';
      btn.className    = 'dp-date-quick-btn';
      btn.dataset.date = ds;
      btn.innerHTML = '<span class="dp-day-label">' + label + '</span>' +
                      '<span class="dp-day-num">'   + padZ(d.getDate()) + '.' + padZ(d.getMonth() + 1) + '</span>';
      btn.addEventListener('click', function () { selectDate(btn, ds); });
      quickContainer.appendChild(btn);
    });
    quickBtns = Array.from(quickContainer.querySelectorAll('.dp-date-quick-btn'));

    if (state.date) {
      var match = quickBtns.find(function (b) { return b.dataset.date === state.date; });
      if (match) { match.classList.add('dp-selected'); buildTimeSlots(state.date); }
      else if (dateInput) dateInput.value = state.date;
    } else if (state.deliveryType) {
      quickBtns[0] && quickBtns[0].click();
    }
  }

  // ── Custom inline calendar ─────────────────────────────────
  var CAL_MONTHS = ['ינואר','פברואר','מרץ','אפריל','מאי','יוני',
                    'יולי','אוגוסט','ספטמבר','אוקטובר','נובמבר','דצמבר'];
  var calEl = null, calYear, calMonth;

  function buildCal() {
    calEl = document.createElement('div');
    calEl.className = 'dp-cal';
    calEl.style.display = 'none';
    calEl.innerHTML =
      '<div class="dp-cal-hdr">' +
        '<button type="button" class="dp-cal-nav" id="dp-cal-prev">›</button>' +
        '<span class="dp-cal-title" id="dp-cal-title"></span>' +
        '<button type="button" class="dp-cal-nav" id="dp-cal-next">‹</button>' +
      '</div>' +
      '<div class="dp-cal-dow"><span>א׳</span><span>ב׳</span><span>ג׳</span>' +
        '<span>ד׳</span><span>ה׳</span><span>ו׳</span><span>ש׳</span></div>' +
      '<div class="dp-cal-grid" id="dp-cal-grid"></div>';
    calendarBtn.parentElement.insertAdjacentElement('afterend', calEl);
    document.getElementById('dp-cal-prev').addEventListener('click', function () {
      calMonth--; if (calMonth < 0) { calMonth = 11; calYear--; } renderCal();
    });
    document.getElementById('dp-cal-next').addEventListener('click', function () {
      calMonth++; if (calMonth > 11) { calMonth = 0; calYear++; } renderCal();
    });
  }

  function renderCal() {
    var title = document.getElementById('dp-cal-title');
    var grid  = document.getElementById('dp-cal-grid');
    if (!title || !grid) return;
    title.textContent = CAL_MONTHS[calMonth] + ' ' + calYear;
    var earliest = getAvailableDates()[0];
    earliest.setHours(0, 0, 0, 0);
    var firstDow    = new Date(calYear, calMonth, 1).getDay();
    var daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
    grid.innerHTML = '';
    for (var i = 0; i < firstDow; i++) {
      var em = document.createElement('span');
      em.className = 'dp-cal-day dp-cal-empty';
      grid.appendChild(em);
    }
    for (var d = 1; d <= daysInMonth; d++) {
      var date = new Date(calYear, calMonth, d);
      date.setHours(0, 0, 0, 0);
      var ds   = fmt(date);
      var sat  = date.getDay() === 6;
      var past = date < earliest;
      var btn  = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dp-cal-day' + (sat ? ' dp-cal-sat' : '');
      btn.textContent = d;
      if (sat || past) {
        btn.disabled = true;
      } else {
        if (state.date === ds) btn.classList.add('dp-cal-sel');
        (function (s) {
          btn.addEventListener('click', function () { selectDate(null, s); closeCal(); });
        })(ds);
      }
      grid.appendChild(btn);
    }
  }

  function openCal() {
    if (!calEl) buildCal();
    var now = new Date();
    calYear = now.getFullYear(); calMonth = now.getMonth();
    renderCal();
    calEl.style.display = '';
  }
  function closeCal() { if (calEl) calEl.style.display = 'none'; }

  function selectDate(btn, dateStr) {
    closeCal();
    if (quickBtns) quickBtns.forEach(function (b) { b.classList.remove('dp-selected'); });
    if (btn) btn.classList.add('dp-selected');
    if (dateInput) dateInput.value = dateStr;
    state.date     = dateStr;
    state.timeSlot = null;
    if (dateErrorMsg) dateErrorMsg.style.display = 'none';
    buildTimeSlots(dateStr);
  }

  function buildTimeSlots(dateStr) {
    var container = document.getElementById('dp-time-slots');
    var grid      = document.getElementById('dp-time-slots-grid');
    if (!container || !grid) return;

    var d     = parseDate(dateStr);
    var slots = d.getDay() === 5 ? SLOTS_FRIDAY : SLOTS_REGULAR;

    // For today: filter slots by availability
    var today = new Date();
    if (dateStr === fmt(today)) {
      if (d.getDay() === 5 && today.getHours() < 15) {
        // Friday same-day: show all Friday slots (ordering allowed until 15:00)
      } else {
        var minStart = today.getHours() + 2;
        slots = slots.filter(function (s) {
          return parseInt(s.split('–')[0], 10) >= minStart;
        });
      }
    }

    grid.innerHTML = '';
    slots.forEach(function (slot) {
      var btn = document.createElement('button');
      btn.type         = 'button';
      btn.className    = 'dp-time-slot-btn';
      btn.textContent  = slot;
      btn.dataset.slot = slot;
      btn.addEventListener('click', function () {
        grid.querySelectorAll('.dp-time-slot-btn').forEach(function (b) { b.classList.remove('dp-selected'); });
        btn.classList.add('dp-selected');
        state.timeSlot = slot;
        setTimeout(advanceFromDate, 350);
      });
      grid.appendChild(btn);
    });

    // Restore previously selected slot (edit mode)
    if (state.timeSlot) {
      var prev = grid.querySelector('[data-slot="' + state.timeSlot + '"]');
      if (prev) prev.classList.add('dp-selected');
    }

    container.style.display = '';
  }

  function advanceFromDate() {
    if (!state.date || !state.timeSlot) return;
    var summary = state.date + ' • ' + state.timeSlot;
    markDone(2, summary);
    updateProgress(2);
    if (state.deliveryType === 'self') {
      if (sec3) sec3.style.display = 'none';
      if (sec4) sec4.style.display = 'none';
      if (submitBtn) {
        submitBtn.classList.remove('dp-submit--hidden');
        submitBtn.classList.add('dp-submit--visible');
      }
    } else {
      openSection(3);
    }
  }

  // ── Address type ───────────────────────────────────────────
  function selectAddressType(type) {
    state.addressType = type;
    document.querySelectorAll('[data-dp-addr]').forEach(function (b) {
      b.classList.toggle('dp-selected', b.dataset.dpAddr === type);
    });
    if (type === 'private') {
      if (privateFields)  privateFields.classList.add('dp-visible');
      if (hospitalFields) hospitalFields.classList.remove('dp-visible');
      setTimeout(function () { cityField && cityField.focus(); }, 50);
    } else {
      if (hospitalFields) hospitalFields.classList.add('dp-visible');
      if (privateFields)  privateFields.classList.remove('dp-visible');
      setTimeout(function () { hospitalNameField && hospitalNameField.focus(); }, 50);
    }
    checkAddressComplete();
  }

  function checkAddressComplete() {
    if (!state.addressType) return false;
    var ok = false;
    if (state.addressType === 'private') {
      ok = !!(cityField && cityField.value.trim() && streetField && streetField.value.trim());
    } else {
      ok = !!(hospitalNameField && hospitalNameField.value.trim());
    }
    if (ok) {
      var addrSummary;
      if (state.addressType === 'private') {
        addrSummary = [cityField.value.trim(), streetField.value.trim(), houseField && houseField.value.trim(), apartmentField && apartmentField.value.trim()]
          .filter(Boolean).join(', ');
      } else {
        addrSummary = hospitalNameField.value.trim();
      }
      markDone(3, addrSummary);
      updateProgress(3);
      if (sec4) sec4.style.display = '';
      openSection(4);
    }
    return ok;
  }

  // ── Recipient readiness ────────────────────────────────────
  function checkRecipientReady() {
    var nameOk  = !!(recipientNameField  && recipientNameField.value.trim());
    var phoneOk = !!(recipientPhoneField && recipientPhoneField.value.trim());
    if (nameOk && phoneOk && submitBtn) {
      submitBtn.classList.remove('dp-submit--hidden');
      submitBtn.classList.add('dp-submit--visible');
    }
  }

  // ── Submit ─────────────────────────────────────────────────
  async function handleSubmit() {
    if (state.deliveryType === 'delivery') {
      if (state.addressType === 'private') {
        state.city            = (cityField       && cityField.value.trim())       || '';
        state.street          = (streetField     && streetField.value.trim())     || '';
        state.houseNumber     = (houseField      && houseField.value.trim())      || '';
        state.apartmentNumber = (apartmentField  && apartmentField.value.trim())  || '';
      } else if (state.addressType === 'hospital') {
        state.hospitalName = (hospitalNameField && hospitalNameField.value.trim()) || '';
        state.department   = (departmentField   && departmentField.value.trim())   || '';
        state.building     = (buildingField     && buildingField.value.trim())     || '';
        state.floor        = (floorField        && floorField.value.trim())        || '';
      }
      state.recipientName  = (recipientNameField  && recipientNameField.value.trim())  || '';
      state.recipientPhone = (recipientPhoneField && recipientPhoneField.value.trim()) || '';
      state.orderNote      = (orderNoteField      && orderNoteField.value.trim())      || '';
    }
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'שומר...'; }
    saveStorage(state);
    await saveCartAttributes(state);
    updateBar();
    closePopup();
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'סיים הזמנה ←'; }
  }

  // ── Open / Close ───────────────────────────────────────────
  function openPopup(editMode) {
    if (!editMode) {
      state = freshState();
      [sec1, sec2, sec3, sec4].forEach(function (s, i) {
        if (!s) return;
        s.style.display = '';
        s.classList.remove('dp-section--active', 'dp-section--done', 'dp-section--locked');
        if (i > 0) s.classList.add('dp-section--locked');
      });
      if (sec1) sec1.classList.add('dp-section--active');
      document.querySelectorAll('.dp-section-summary').forEach(function (el) { el.textContent = ''; });
      document.querySelectorAll('.dp-type-card, .dp-date-quick-btn, .dp-addr-type-btn').forEach(function (b) { b.classList.remove('dp-selected'); });
      if (privateFields)  privateFields.classList.remove('dp-visible');
      if (hospitalFields) hospitalFields.classList.remove('dp-visible');
      var progressEl = document.getElementById('dp-progress');
      if (progressEl) progressEl.classList.remove('dp-progress--two-step');
      var pickupInfo = document.getElementById('dp-pickup-info');
      if (pickupInfo) pickupInfo.style.display = 'none';
      var timeSlotsEl = document.getElementById('dp-time-slots');
      if (timeSlotsEl) timeSlotsEl.style.display = 'none';
      var timeSlotsGrid = document.getElementById('dp-time-slots-grid');
      if (timeSlotsGrid) timeSlotsGrid.innerHTML = '';
      if (dateInput) dateInput.value = '';
      if (submitBtn) {
        submitBtn.classList.add('dp-submit--hidden');
        submitBtn.classList.remove('dp-submit--visible');
      }
      modal.querySelectorAll('.dp-field').forEach(function (f) { if (f.tagName !== 'TEXTAREA') f.value = ''; });
      updateProgress(0);
    } else {
      var saved = loadStorage();
      if (saved) Object.assign(state, saved);
    }
    buildQuickDates();
    overlay.classList.add('dp-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('dp-open');
    document.body.style.overflow = '';
    // If the user dismissed the popup without completing it,
    // allow the pending checkout to proceed anyway.
    var saved = loadStorage();
    if (_pendingCheckoutTrigger && (!saved || !saved.deliveryType)) {
      var trigger = _pendingCheckoutTrigger;
      _pendingCheckoutTrigger = null;
      setTimeout(function () { trigger.click(); }, 50);
    } else {
      _pendingCheckoutTrigger = null;
    }
  }

  // ── Bar update ─────────────────────────────────────────────
  function buildBarText(data) {
    if (!data || !data.deliveryType) return null;
    var parts = [data.deliveryType === 'self' ? 'איסוף עצמי' : 'משלוח'];
    if (data.date) {
      var datePart = 'ב-' + data.date;
      if (data.timeSlot) datePart += ' ' + data.timeSlot;
      parts.push(datePart);
    }
    if (data.deliveryType === 'delivery') {
      if (data.addressType === 'private') {
        var addr = [data.city, data.street, data.houseNumber, data.apartmentNumber].filter(Boolean).join(', ');
        if (addr) parts.push(addr);
      } else if (data.addressType === 'hospital' && data.hospitalName) {
        parts.push(data.hospitalName);
      }
    }
    return parts.join(' | ');
  }

  function updateBar() {
    var data = loadStorage();
    document.querySelectorAll('[data-delivery-bar]').forEach(function (bar) {
      var textEl = bar.querySelector('.dp-bar-btn__text');
      if (!textEl) return;
      textEl.textContent = buildBarText(data) || (bar.dataset.defaultText || 'בחר תאריך וכתובת למשלוח');
    });
  }

  // ── Init ───────────────────────────────────────────────────
  function init() {
    overlay = document.getElementById('dp-overlay');
    if (!overlay) return;

    modal              = overlay.querySelector('.dp-modal');
    sec1               = document.getElementById('dp-sec-1');
    sec2               = document.getElementById('dp-sec-2');
    sec3               = document.getElementById('dp-sec-3');
    sec4               = document.getElementById('dp-sec-4');
    sum1               = document.getElementById('dp-sum-1');
    sum2               = document.getElementById('dp-sum-2');
    sum3               = document.getElementById('dp-sum-3');
    sum4               = document.getElementById('dp-sum-4');
    quickContainer     = document.getElementById('dp-date-quick');
    dateInput          = document.getElementById('dp-date-input');
    calendarBtn        = document.getElementById('dp-calendar-btn');
    dateErrorMsg       = document.getElementById('dp-date-error');
    privateFields      = document.getElementById('dp-private-fields');
    hospitalFields     = document.getElementById('dp-hospital-fields');
    cityField          = document.getElementById('dp-city');
    streetField        = document.getElementById('dp-street');
    houseField         = document.getElementById('dp-house');
    apartmentField     = document.getElementById('dp-apartment');
    hospitalNameField  = document.getElementById('dp-hospital-name');
    departmentField    = document.getElementById('dp-department');
    buildingField      = document.getElementById('dp-building');
    floorField         = document.getElementById('dp-floor');
    recipientNameField  = document.getElementById('dp-recipient-name');
    recipientPhoneField = document.getElementById('dp-recipient-phone');
    orderNoteField      = document.getElementById('dp-order-note');
    submitBtn           = document.getElementById('dp-submit-btn');

    // Close handlers
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    modal.querySelector('.dp-close').addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

    // Completed section header → re-open for editing
    [sec1, sec2, sec3, sec4].forEach(function (sec) {
      var hdr = sec && sec.querySelector('.dp-section-hdr');
      if (hdr) {
        hdr.addEventListener('click', function () {
          if (sec.classList.contains('dp-section--done')) openSection(
            [sec1, sec2, sec3, sec4].indexOf(sec) + 1
          );
        });
      }
    });

    // Section 1 — delivery type cards
    document.querySelectorAll('[data-dp-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.deliveryType = btn.dataset.dpType;
        document.querySelectorAll('[data-dp-type]').forEach(function (b) { b.classList.remove('dp-selected'); });
        btn.classList.add('dp-selected');
        var isSelf = state.deliveryType === 'self';
        var label  = isSelf ? 'איסוף עצמי' : 'משלוח עם שליח';
        // For self-pickup: hide address + recipient sections
        if (sec3) sec3.style.display = isSelf ? 'none' : '';
        if (sec4) sec4.style.display = isSelf ? 'none' : '';
        // Toggle 2-step progress bar for self-pickup
        var progressEl = document.getElementById('dp-progress');
        if (progressEl) progressEl.classList.toggle('dp-progress--two-step', isSelf);
        // Show/hide pickup address info in section 2
        var pickupInfo = document.getElementById('dp-pickup-info');
        if (pickupInfo) pickupInfo.style.display = isSelf ? 'flex' : 'none';
        markDone(1, label);
        updateProgress(1);
        openSection(2);
        buildQuickDates();
      });
    });

    // Section 2 — calendar button (custom inline calendar)
    if (calendarBtn) {
      calendarBtn.addEventListener('click', function () {
        if (calEl && calEl.style.display !== 'none') { closeCal(); } else { openCal(); }
      });
    }

    // Section 3 — address type buttons
    document.querySelectorAll('[data-dp-addr]').forEach(function (btn) {
      btn.addEventListener('click', function () { selectAddressType(btn.dataset.dpAddr); });
    });

    // Section 3 — advance only when focus leaves the entire section
    if (sec3) {
      sec3.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !sec3.contains(e.relatedTarget)) {
          checkAddressComplete();
        }
      });
    }

    // Section 4 — reveal submit when name + phone filled
    [recipientNameField, recipientPhoneField].forEach(function (f) {
      if (f) f.addEventListener('input', checkRecipientReady);
    });

    // Submit
    if (submitBtn) submitBtn.addEventListener('click', handleSubmit);

    // Skip button — allow checkout without filling popup
    var skipBtn = document.getElementById('dp-skip-btn');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        _pendingCheckoutTrigger = null; // don't re-fire via closePopup
        closePopup();
        // Navigate to checkout directly
        window.location.href = '/checkout';
      });
    }

    // Delivery bar → reopen for editing
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-delivery-bar]')) openPopup(true);
    });

    // Cart intercept — Wokiee pubsub
    if (window.subscribe) {
      try { window.subscribe('cart:item-added', handleCartItemAdded); } catch (_) {}
    }
    document.addEventListener('cart:item-added', handleCartItemAdded);
    document.querySelectorAll('form[action="/cart/add"]').forEach(hookForm);
    new MutationObserver(function () {
      document.querySelectorAll('form[action="/cart/add"]:not([data-dp-hooked])').forEach(hookForm);
    }).observe(document.body, { childList: true, subtree: true });
    interceptCartAddFetch();

    hookCheckout();
    updateBar();
  }

  function hookForm(form) {
    if (form.dataset.dpHooked) return;
    form.dataset.dpHooked = '1';
    form.addEventListener('submit', function (e) {
      var saved = loadStorage();
      if (!saved || !saved.deliveryType) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function () { document.dispatchEvent(new CustomEvent('cart:item-added')); openPopup(false); })
          .catch(function () { openPopup(false); });
      } else {
        // Popup was filled before — re-sync attributes to this cart session
        saveCartAttributes(saved);
      }
    }, true);
  }

  function handleCartItemAdded() {
    if (window.__upShowing) return;
    var saved = loadStorage();
    if (!saved || !saved.deliveryType) {
      openPopup(false);
    } else {
      // Re-sync attributes to cart on every item add (handles fresh cart after prev order)
      saveCartAttributes(saved);
    }
  }

  function interceptCartAddFetch() {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add')) {
        return orig.apply(this, arguments).then(function (res) {
          var saved = loadStorage();
          if (!saved || !saved.deliveryType) {
            res.clone().json().then(function () { setTimeout(function () { if (!window.__upShowing) openPopup(false); }, 300); }).catch(function () {});
          } else {
            // Re-sync attributes to cart (fetch-based add)
            saveCartAttributes(saved);
          }
          return res;
        });
      }
      return orig.apply(this, arguments);
    };
  }

  // ── Checkout gate — show popup as suggestion, not hard block ──
  function hookCheckout() {
    // Intercept clicks on any checkout trigger (capture phase = fires before theme JS)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        'button[name="checkout"], [data-checkout], a[href$="/checkout"], a[href*="/checkouts/"]'
      );
      if (!trigger) return;
      var saved = loadStorage();
      if (!saved || !saved.deliveryType) {
        e.preventDefault();
        e.stopImmediatePropagation();
        _pendingCheckoutTrigger = trigger; // remember where to return
        openPopup(false);
      }
    }, true);

    // Also intercept cart form submit with the checkout submitter
    function hookCartForm(form) {
      if (form.dataset.dpCartHooked) return;
      form.dataset.dpCartHooked = '1';
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.name !== 'checkout') return;
        var saved = loadStorage();
        if (!saved || !saved.deliveryType) {
          e.preventDefault();
          e.stopImmediatePropagation();
          _pendingCheckoutTrigger = e.submitter || null;
          openPopup(false);
        }
      }, true);
    }

    document.querySelectorAll('form[action="/cart"]').forEach(hookCartForm);
    new MutationObserver(function () {
      document.querySelectorAll('form[action="/cart"]:not([data-dp-cart-hooked])').forEach(hookCartForm);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ── Boot ───────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.DeliveryPopup = {
    open:      function () { openPopup(false); },
    edit:      function () { openPopup(true); },
    updateBar: updateBar,
  };

})();